window.cabjaks = window.cabjaks || {};

cabjaks.currentVariant = null;
cabjaks.currentVariantDetails = null;
cabjaks.productpageFirstRun = true;
cabjaks.benchtopChosen = false;
cabjaks.sinkChosen = false;
cabjaks.handleChosen = false;
cabjaks.softCloseChosen = false;
cabjaks.softHingeChosen = false;
cabjaks.cornerLazySusanChosen = false;
cabjaks.itemsToAdd = [];

cabjaks.cacheSelectors = function () {
	cabjaks.cache = {
		// General
		$html: $('html'),
		$body: $('body'),

		// Navigation
		$navigation: $('#AccessibleNav'),

		// Product Page
		$productImage: $('#ProductPhotoImg'),
		$thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail')
	};
};

cabjaks.init = function () {
	cabjaks.cacheSelectors();
	cabjaks.accessibleNav();
	cabjaks.mobileNav();
	cabjaks.scrollToTop();
	cabjaks.productImageSwitch();
	cabjaks.responsiveVideos();
	//cabjaks.googleMap();
	cabjaks.handleSlick();
};

cabjaks.accessibleNav = function () {
	var $nav = cabjaks.cache.$navigation,
		$allLinks = $nav.find('a'),
		$topLevel = $nav.children('li').find('a'),
		$parents = $nav.find('.site-nav--has-dropdown'),
		$subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
		activeClass = 'nav-hover',
		focusClass = 'nav-focus';

	// Mouseenter
	$parents.on('mouseenter touchstart', function(evt) {
		var $el = $(this);

		if (!$el.hasClass(activeClass)) {
			evt.preventDefault();
		}

		showDropdown($el);
	});

	// Mouseout
	$parents.on('mouseleave', function() {
		hideDropdown($(this));
	});

	$subMenuLinks.on('touchstart', function(evt) {
		// Prevent touchstart on body from firing instead of link
		evt.stopImmediatePropagation();
	});

	$allLinks.focus(function() {
		handleFocus($(this));
	});

	$allLinks.blur(function() {
		removeFocus($topLevel);
	});

	// accessibleNav private methods
	function handleFocus ($el) {
		var $subMenu = $el.next('ul'),
				hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
				isSubItem = $('.site-nav__dropdown').has($el).length,
				$newFocus = null;

		// Add focus class for top level items, or keep menu shown
		if (!isSubItem) {
			removeFocus($topLevel);
			addFocus($el);
		} else {
			$newFocus = $el.closest('.site-nav--has-dropdown').find('a');
			addFocus($newFocus);
		}
	}

	function showDropdown ($el) {
		$el.addClass(activeClass);
		$el.siblings().removeClass(activeClass);

		setTimeout(function() {
			cabjaks.cache.$body.on('touchstart', function() {
				hideDropdown($el);
			});
		}, 250);
	}

	function hideDropdown ($el) {
		setTimeout(function() {
			$el.removeClass(activeClass);
			cabjaks.cache.$body.off('touchstart');
		}, 250);
	}

	function addFocus ($el) {
		$el.addClass(focusClass);
	}

	function removeFocus ($el) {
		$el.removeClass(focusClass);
	}
};

cabjaks.mobileNav = function () {
	$('.mobile-nav').on('click', function(e) {
		e.preventDefault();
		$('body').toggleClass('left-nav-shown');
	});
};

cabjaks.scrollToTop = function () {
	$('.back-to-top').on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: 0
		});
	});
};

cabjaks.productPage = function (options) {
		var moneyFormat = options.money_format,
				variant = options.variant,
						selector = options.selector;


							// Selectors
								var $productImage = $('#ProductPhotoImg'),
										$addToCart = $('#AddToCart'),
												$productPrice = $('#ProductPrice'),
														$comparePrice = $('#ComparePrice'),
																$quantityElements = $('.js-qty'),
																		$addToCartText = $('#AddToCartText'),
																				$productUpsells = $('.product-single__upsells');

																					if (variant) {
																							// If upsells are displayed
																									if($productUpsells.length) {

																												// Only run if variant has actually changed
																															if(cabjaks.currentVariant != variant.id) {

																																			// Update variant
																																							cabjaks.currentVariant = variant.id;
																																											cabjaks.currentVariantDetails = variant;
																																											// Update soft-close hinges for the selected cabinet height
$productUpsells.find('.soft-hinge button').each(function() {
  var $button = $(this),
      heightOption = parseInt($button.attr('data-height-option'), 10),
      selectedHeight = heightOption > 0
        ? parseInt(variant['option' + heightOption], 10)
        : null,
      standardQty = parseInt($button.attr('data-standard-qty'), 10),
      tallQty = parseInt($button.attr('data-tall-qty'), 10),
      unitPrice = parseInt($button.attr('data-unit-price'), 10),
      hingeQty = selectedHeight === 2300 && !isNaN(tallQty)
        ? tallQty
        : standardQty;

  if (isNaN(hingeQty) || isNaN(unitPrice)) {
    return;
  }

  // Update both the HTML attribute and jQuery's cached quantity
  $button.attr('data-qty', hingeQty).data('qty', hingeQty);

  // Update desktop and mobile upsell prices
  $button.closest('.upsell-item').find('p.price').html(
    Shopify.formatMoney(unitPrice * hingeQty, moneyFormat)
  );
});

// If benchtops are displayed
if ($productUpsells.find('.benchtops').length) {
  // Set kitchenette width and depth
  var kWidth = variant.option1,
    kDepth = variant.option2,
    bWidth,
    bDepth,
    benchtopFound = false;

  // Double-check that kitchenette has width and depth set
  if (kWidth && kDepth) {
    // Convert width and depth to a number
    kWidth = parseInt(kWidth.trim().replace("mm", ""), 10);
    kDepth = parseInt(kDepth.trim().replace("mm", ""), 10);

    // Benchtop width = kitchenette width + 20mm
    bWidth = kWidth + 20;

    // Set benchtop depth depending on kitchenette depth
    if (kDepth == 585) {
      bDepth = 600;
    } else if (kDepth == 485) {
      bDepth = 500;
    } else if (kDepth == 445) {
      bDepth = 460;
    } else if (kDepth == 332) {
      bDepth = 347;
    }

    // Unselect existing upsells if product has changed (because the benchtop or sink might not fit anymore)
    $productUpsells.find('.benchtops button, .sinks button').removeClass('selected').text('Select');
    // Clear saved properties
    $productUpsells.find('input.sink-info, input.benchtop-info').val('').attr('name', '');
    cabjaks.benchtopChosen = false;
    cabjaks.sinkChosen = false;

    // Loop through benchtop colours
    $productUpsells.find('.benchtops .upsell-item').each(function() {
      var $upsellItem = $(this),
        sizeFound = false;

      // Loop through sizes to find a matching benchtop
      $upsellItem.find('input[type=hidden]').each(function() {
        var $benchtopInfo = $(this);

        // If a benchtop is found at the right size
        if (bWidth + 'mm' == $benchtopInfo.data('width') && bDepth + 'mm' == $benchtopInfo.data('depth')) {
          // Update button to correct ID
          $benchtopInfo.siblings('button').data('id', $benchtopInfo.data('id'));
          // Update displayed price
          $upsellItem.find('p.price').text($benchtopInfo.data('price'));
          sizeFound = true;
        }
      });

      if (!sizeFound) {
        // Hide colour if no matching sizes found
        $upsellItem.hide();
      } else {
        // Show row in case it was previously hidden
        $upsellItem.show();
        benchtopFound = true;
      }
    });

    // Invalid width/depth - hiding benchtops
  } else {
    $productUpsells.find('.benchtops .upsell-item').hide();
  }

  if (!benchtopFound) {
    // Show error message
    $productUpsells.find('.benchtops p.no-products').show();
  } else {
    // Hide error message in case it was previously shown
    $productUpsells.find('.benchtops p.no-products').hide();
  }
}

// Now let's do sinks!
if ($productUpsells.find('.sinks').length) {

  var sinksFound = false;

  // Loop through sinks
  $productUpsells.find('.sinks .upsell-item').each(function() {
    var $upsellItem = $(this),
      sinkFitsIds = [];

    // Get the list of kitchenette IDs which fit this sink, convert it to an array
    sinkFitsIds = $upsellItem.find('button').data('fits').split(',');

    // Convert each ID into an integer
    if (sinkFitsIds.length) {
      for (var i = 0; i < sinkFitsIds.length; i++) {
        sinkFitsIds[i] = parseInt(sinkFitsIds[i], 10);
      }
    }

    if ($.inArray(variant.id, sinkFitsIds) != -1) {
      // Show row in case it was previously hidden
      $upsellItem.show();
      sinksFound = true;
    } else {
      // Hide sink if it doesn't fit
      $upsellItem.hide();
    }
  });

  if (!sinksFound) {
    // Show error message
    $productUpsells.find('.sinks p.no-products').show();
  } else {
    // Hide error message in case it was previously shown
    $productUpsells.find('.sinks p.no-products').hide();
  }
}
}
}

// Select a valid variant if available
if (variant.available) {
  // Available, enable the submit button, change text, show quantity elements
  $addToCart.removeClass('disabled').prop('disabled', false);
  $addToCartText.html("Add to Cart");
  $quantityElements.show();
} else {
  // Sold out, disable the submit button, change text, hide quantity elements
  $addToCart.addClass('disabled').prop('disabled', true);
  $addToCartText.html("Sold Out");
  $quantityElements.hide();
}

// Regardless of stock, update the product price
$productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
$productPrice.attr('data-product-price', Shopify.formatMoney(variant.price, moneyFormat));
cabjaks.updateUpsellProductPrice();

// Also update and show the product's compare price if necessary
if (variant.compare_at_price > variant.price) {
  $comparePrice.html("Normally " + Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
} else {
  $comparePrice.hide();
}

// Update variant image, if one is set
if (variant.featured_image) {
  // Only update the product image when a variant has been chosen
  // This is not desired when the variable is passed in by the URL but it's ok for now
  if (cabjaks.productpageFirstRun) {
    cabjaks.productpageFirstRun = false;
  } else {
    var newImg = variant.featured_image,
      el = $productImage[0];
    cabjaks.switchVariantImage(newImg, el);
  }
}

} else {
  // The variant doesn't exist, disable submit button.
  // This may be an error or notice that a specific variant is not available.
  // To only show available variants, implement linked product options:
  //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
  $addToCart.addClass('disabled').prop('disabled', true);
  $addToCartText.html("Unavailable");
  $quantityElements.hide();
}

//shift quantity selector upwards on mobile
if ($(window).width() <= 480) {
  $('.qty-addtocart-content .js-qty').insertAfter($('.additional-selector-wrapper.quantity-label label'));
}

//active thumbnail for the first product thumbnail image
$('.product-single__thumbnails li:first-child a img').addClass('active-thumbnail');
};

// Wardrobe product
cabjaks.wardrobeProduct = function (options) {
	var moneyFormat = options.money_format;

	var $wardrobeSelectors = $('.wardrobe-selectors'),
	$productOrderForm = $('.product-single__order-form'),
	width = $wardrobeSelectors.find('#overall-width').val(),
	height = $wardrobeSelectors.find('#overall-height').val(),
	depth = $wardrobeSelectors.find('#overall-depth').val(),
	towerWidth = $wardrobeSelectors.find('#tower-width').val(),
	railWidth,
	railSections = 2;

	// Loop through order form items and only show the products which match the current wardrobe dimensions
	function findMatch() {
		var totalPrice = 0;

		$productOrderForm.find('.form-item').each(function() {
			var $formItem = $(this),
			sizeFound = false,
			qty = parseInt($formItem.find('input[name=quantity]').val()),
			linePrice;

			// Only look for matching size if needed
			if(!$formItem.hasClass('match-none')) {
				// Loop through sizes to find a matching product
				$formItem.find('input[type=hidden]').each(function() {
					var $productInfo = $(this),
					matchFound = false,
					sizeInfo;

					if($formItem.hasClass('match-height') && $formItem.hasClass('match-depth')) {
						if(height + 'mm' == $productInfo.data('height') && depth + 'mm' == $productInfo.data('depth')) {
							matchFound = true;
							sizeInfo = $productInfo.data('height') + ' H &times; ' + $productInfo.data('depth') + ' D';
						}
					} else if($formItem.hasClass('match-width') && $formItem.hasClass('match-depth')) {
						if(width + 'mm' == $productInfo.data('width') && depth + 'mm' == $productInfo.data('depth')) {
							matchFound = true;
							sizeInfo = $productInfo.data('width') + ' W &times; ' + $productInfo.data('depth') + ' D';
						}
					} else if($formItem.hasClass('match-depth') && $formItem.hasClass('match-tower-width')) {
						if(depth + 'mm' == $productInfo.data('depth') && towerWidth + 'mm' == $productInfo.data('width')) {
							matchFound = true;
							sizeInfo = $productInfo.data('width') + ' W &times; ' + $productInfo.data('depth') + ' D';
						}
					} else if($formItem.hasClass('match-rail-width')) {
						// Rail width should as long as the available rail or less (often won't match exactly because it depends on the overall width AND the tower width)
						if(railWidth <= parseInt($productInfo.data('width').replace("mm", ""), 10)) {
							matchFound = true;
							sizeInfo = $productInfo.data('width') + ' W';
						}
					} else if($formItem.hasClass('match-tower-width')) {
						if(towerWidth + 'mm' == $productInfo.data('width')) {
							matchFound = true;
							sizeInfo = $productInfo.data('width') + ' W';
						}
					}

					// If a product is found at the right size
					if(matchFound) {
						// Add selected class
						$productInfo.addClass('selected').siblings().removeClass('selected');
						// Update displayed price
						$formItem.find('p.price').text($productInfo.data('price'));
						// Append selected product size
						if(!$formItem.find('p.size').length) {
							$formItem.find('p.price').before('<p class="size"></p>')
						}
						$formItem.find('p.size').html(sizeInfo);
						sizeFound = true;
						// Stop looping!
						return false;
					}
				});

				if(!sizeFound) {
					// Hide item if no matching sizes found
					$formItem.hide().find('input.selected').removeClass('selected');
				} else {
					// Show item in case it was previously hidden
					$formItem.show();
				}
			}

			// Update total price
			linePrice = (parseInt($formItem.find('input.selected').data('price-raw'), 10) * qty);
			totalPrice = totalPrice + linePrice;
		});

		// Update final product price
		$('#ProductPrice').html( Shopify.formatMoney(totalPrice, moneyFormat) );
	}

	if(width && height && depth && towerWidth) {
		width = parseInt(width.trim().replace("mm", ""), 10);
		height = parseInt(height.trim().replace("mm", ""), 10);
		depth = parseInt(depth.trim().replace("mm", ""), 10);
		towerWidth = parseInt(towerWidth.trim().replace("mm", ""), 10);

		railWidth = (width - towerWidth) / railSections;

		findMatch();

		$wardrobeSelectors.find('select').on('change', function() {
			var $this = $(this),
			option = $(this).val();
			option = parseInt(option.trim().replace("mm", ""), 10);

			if($this.is('#overall-width')) {
				width = option;
				railWidth = (width - towerWidth) / railSections;
			} else if($this.is('#overall-height')) {
				height = option;
			} else if($this.is('#overall-depth')) {
				depth = option;
			} else if($this.is('#tower-width')) {
				towerWidth = option;
				railWidth = (width - towerWidth) / railSections;
			}

			// Update products
			findMatch();
		});
	}

	// Update price on quantity change
	function updateWardrobePrice() {
		var totalPrice = 0;

		$productOrderForm.find('.form-item').each(function() {
			var $formItem = $(this),
			qty = parseInt($formItem.find('input[name=quantity]').val(), 10),
			linePrice = (parseInt($formItem.find('input.selected').data('price-raw'), 10) * qty);

			totalPrice = totalPrice + linePrice;
		});

		// Update final product price
		$('#ProductPrice').html( Shopify.formatMoney(totalPrice, moneyFormat) );
	}

	// On order form quantity change
	$productOrderForm.find('input[name=quantity]').on('change', function() {
		updateWardrobePrice();
	});

	$productOrderForm.find('.js-qty__adjust').on('click', function() {
		updateWardrobePrice();
	});

	//shift quantity selector upwards on mobile
	if($(window).width() <= 480){
		$('.qty-addtocart-content .js-qty').insertAfter($('.additional-selector-wrapper.quantity-label label'));
	}
};

// Special panel product
cabjaks.specialPanelProduct = function (options) {
	var moneyFormat = options.money_format;

	var $addToCartForm = $('form#AddToCartForm'),
	$productSelect = $addToCartForm.find('select#productSelect'),
	$productPrice = $addToCartForm.find('span#ProductPrice'),
	$panelLength = $addToCartForm.find('input#panel-length'),
	$panelWidth = $addToCartForm.find('input#panel-width'),
	$edging1 = $addToCartForm.find('input#edging-standard-1'),
	$edging2 = $addToCartForm.find('input#edging-standard-2'),
	$edgingLong1 = $addToCartForm.find('input#edging-long-1'),
	$edgingLong2 = $addToCartForm.find('input#edging-long-2'),
	$edgingThickness = $addToCartForm.find('select#edging-thickness'),
	$hingeHoles = $addToCartForm.find('select#hinge-holes'),	
	maxShortLength = 1200,
	variantID = null,
	validateLength = false,
	validateWidth = false,
	panelLength = null,
	panelWidth = null,
	panelArea = null,
	leftEdging = 'No',
	topEdging = 'No',
	bottomEdging = 'No',
	rightEdging = 'No',
	edging1Qty = 0,
	edging2Qty = 0,
	edgingLong1Qty = 0,
	edgingLong2Qty = 0,
	edging1Price = $edging1.data('price'),
	edging2Price = $edging2.data('price'),
	edgingLong1Price = $edgingLong1.data('price'),
	edgingLong2Price = $edgingLong2.data('price'),
	edgingThickness = '1mm',
	hingeHoleQty = 0,
	hingeHolePrice = $hingeHoles.data('price'),
	currentlyEditing,
	typingTimer;

	// Add error to field + general step error
	function addError($this, msg) {
		window.scrollTo(0, $addToCartForm.offset().top - $('.site-header').height());
		$this.addClass('error').closest('form').find('.form-error').addClass('shown').html('<p>' + msg + '</p>');
	}

	// Remove error from field + remove general step error
	function removeError($this) {
		$this.removeClass('error').closest('form').find('.form-error').removeClass('shown');
	}

	function updatePrice() {
		var newPrice = 0;

		if(panelLength && panelWidth) {
			panelArea = Math.round(((panelWidth/1000) * (panelLength/1000)) * 100) / 100;

			// Reset edging
			edging1Qty = 0;
			edging2Qty = 0;
			edgingLong1Qty = 0;
			edgingLong2Qty = 0;

			$productSelect.find('option').each(function() {
				var $this = $(this);
				const $selectedColour = $addToCartForm.find('[name="custom-panel-colour"]:checked');
				if(panelArea <= $this.data('variant') && $this.html().toLowerCase().includes($selectedColour.val().toLowerCase())) {
					$this.prop('selected', true);
					variantID = $this.val();
					newPrice = $this.data('price');

					// Edging
					if(leftEdging == 'Yes') {
						if(edgingThickness == '1mm') {
							if(panelLength > 1000) {
								edgingLong1Qty++;
							} else {
								edging1Qty++;
							}

						} else if(edgingThickness == '2mm') {
							if(panelLength > 1000) {
								edgingLong2Qty++;
							} else {
								edging2Qty++;
							}
						}
					}

					if(topEdging == 'Yes') {
						if(edgingThickness == '1mm') {
							if(panelWidth > 1000) {
								edgingLong1Qty++;
							} else {
								edging1Qty++;
							}

						} else if(edgingThickness == '2mm') {
							if(panelWidth > 1000) {
								edgingLong2Qty++;
							} else {
								edging2Qty++;
							}
						}
					}

					if(bottomEdging == 'Yes') {
						if(edgingThickness == '1mm') {
							if(panelWidth > 1000) {
								edgingLong1Qty++;
							} else {
								edging1Qty++;
							}

						} else if(edgingThickness == '2mm') {
							if(panelWidth > 1000) {
								edgingLong2Qty++;
							} else {
								edging2Qty++;
							}
						}
					}

					if(rightEdging == 'Yes') {
						if(edgingThickness == '1mm') {
							if(panelLength > 1000) {
								edgingLong1Qty++;
							} else {
								edging1Qty++;
							}

						} else if(edgingThickness == '2mm') {
							if(panelLength > 1000) {
								edgingLong2Qty++;
							} else {
								edging2Qty++;
							}
						}
					}

					if(edging1Qty > 0 || edgingLong1Qty > 0 || edging2Qty > 0 || edgingLong2Qty > 0) {
						newPrice += ((edging1Qty * edging1Price) + (edgingLong1Qty * edgingLong1Price));
					}

					// Hide or show edging thickness dropdown
					// if(leftEdging == 'Yes' || topEdging == 'Yes' || bottomEdging == 'Yes' || rightEdging == 'Yes') {
					// 	$edgingThickness.parent().removeClass('hidden');
					// } else {
					// 	$edgingThickness.parent().addClass('hidden');
					// }

					// Hinge holes
					hingeHoleQty = parseInt($hingeHoles.val());

					if(hingeHoleQty > 0) {
						newPrice += (hingeHolePrice * hingeHoleQty);
					}

					if(newPrice > 0) {
						$productPrice.html( Shopify.formatMoney(newPrice, moneyFormat) );
					}
					
					// Break loop
					return false;
				}
			});
		}
	}

	function validateMeasurements() {
		var min = parseInt($panelWidth.attr('min'), 10), // same for width and length
		max = parseInt($panelWidth.attr('max'), 10),
		origLengthVal = $panelLength.val(),
		origWidthVal = $panelWidth.val(),
		lengthVal = parseInt(origLengthVal, 10),
		widthVal = parseInt(origWidthVal, 10);

		removeError($panelLength);
		removeError($panelWidth);

		if(validateLength) {
			if(origLengthVal == lengthVal && lengthVal >= min && lengthVal <= max) {
				// Save value
				panelLength = lengthVal;
			} else {
				panelLength = null;
				addError($panelLength, 'Please enter a valid length - number only, between ' + min + ' and ' + max + ' millimetres.');
			}
		}
		
		if(validateWidth) {
			if(origWidthVal == widthVal && widthVal >= min && widthVal <= max) {
				// Save value
				panelWidth = widthVal;
			} else {
				panelWidth = null;
				addError($panelWidth, 'Please enter a valid width - number only, between ' + min + ' and ' + max + ' millimetres.');
			}
		}

		if(panelLength && panelWidth) {
			if(panelWidth <= panelLength) {
				if(panelWidth <= maxShortLength) {
					updatePrice();
				} else {
					panelWidth = null;
					addError($panelWidth, 'Width cannot be more than ' + maxShortLength + 'mm.');
				}
			} else {
				if(panelLength <= maxShortLength) {
					updatePrice();
				} else {
					panelLength = null;
					addError($panelLength, 'Length cannot be more than ' + maxShortLength + 'mm.');
				}
			}
		}
	}

	$addToCartForm.find('input[type=number]').on('keyup', function() {
		var $this = $(this);

		// Keep the timer running on box switch (so that typing in the new box doesn't prevent the old box saving)
		// If same box
		if(currentlyEditing == $this.attr('id')) {
			clearTimeout(typingTimer);
		// If new box, save the new box
		} else {
			currentlyEditing = $this.attr('id');
		}

		// See which fields to validate
		if($this.is('#panel-length')) {
			validateLength = true;
		} else if($this.is('#panel-width')) {
			validateWidth = true;
		}

		// Validate a bit faster if there's an error already (otherwise it feels clunky)
		if($this.hasClass('error')) {
			typingTimer = setTimeout(function() {
				validateMeasurements();
			}, 800);
		} else {
			typingTimer = setTimeout(function() {
				validateMeasurements();
			}, 2000);
		}
	});

	$addToCartForm.find('input[type=radio]').on('change', function() {
		var $this = $(this),
		side = $this.attr('title'),
		edging = $this.val();

		if(side == 'Left Edging') {
			leftEdging = edging;

		} else if(side == 'Top Edging') {
			topEdging = edging;

		} else if(side == 'Bottom Edging') {
			bottomEdging = edging;

			if(edging == 'Yes') {
				if(rightEdging == 'Yes') {
					$this.closest('.diagram').find('img.edging').addClass('shown').siblings('img').removeClass('shown');
				} else {
					$this.closest('.diagram').find('img.no-edging-right').addClass('shown').siblings('img').removeClass('shown');
				}
			} else {
				if(rightEdging == 'Yes') {
					$this.closest('.diagram').find('img.no-edging-bottom').addClass('shown').siblings('img').removeClass('shown');
				} else {
					$this.closest('.diagram').find('img.no-edging').addClass('shown').siblings('img').removeClass('shown');
				}
			}

		} else if(side == 'Right Edging') {
			rightEdging = edging;

			if(edging == 'Yes') {
				if(bottomEdging == 'Yes') {
					$this.closest('.diagram').find('img.edging').addClass('shown').siblings('img').removeClass('shown');
				} else {
					$this.closest('.diagram').find('img.no-edging-bottom').addClass('shown').siblings('img').removeClass('shown');
				}
			} else {
				if(bottomEdging == 'Yes') {
					$this.closest('.diagram').find('img.no-edging-right').addClass('shown').siblings('img').removeClass('shown');
				} else {
					$this.closest('.diagram').find('img.no-edging').addClass('shown').siblings('img').removeClass('shown');
				}
			}
		} else if(edging == 'White') {
			$('option[value="2mm"]', $edgingThickness).prop('disabled', false);
		} else if($this.attr('name') == 'custom-panel-colour' && edging != 'White'){
			$('option[value="2mm"]', $edgingThickness).prop('disabled', true);
			if(edgingThickness == '2mm'){
				$('option[value="1mm"]', $edgingThickness).prop('selected', true);
				edgingThickness = '1mm';
			}
		}

		updatePrice();
	});

	$edgingThickness.on('change', function() {
		edgingThickness = $edgingThickness.val();
		updatePrice();
	});

	$hingeHoles.on('change', function() {
		updatePrice();
	});

	$('button#AddToCart').on('click', function(){
		validateMeasurements();
	});

	$addToCartForm.on('submit', function(e) {
		e.preventDefault();
		var $this = $(this);		
		const selectedColour = $addToCartForm.find('[name="custom-panel-colour"]:checked').val();

		$.getJSON( "/cart.js")
		.done(function( response ) {
			//validate colour firsts
			for(var i=0; i < response.items.length; i++){
				if(response.items[i].product_title != 'Custom Benchtop' && !response.items[i].product_title.includes('Custom Stone') && response.items[i].properties){				
					for (const [key, value] of Object.entries(response.items[i].properties)){
						if(key == 'Colour' || key == '_Colour'){
							if(selectedColour != value){
								Swal.fire({
									text: "You can't have more than 1 colour in your cart",
									icon: 'error',
									confirmButtonColor: '#3085d6',
									cancelButtonColor: '#d33',
									confirmButtonText: 'OK'
								});
								return;
							}
						}
					}
				}
			}			

			var $submitButton = $this.find('button#AddToCart'),
			qty = parseInt($this.find('.js-qty input').val(), 10),
			panelProperties = {},
			leftEdgingProp,
			topEdgingProp,
			bottomEdgingProp,
			rightEdgingProp;

			// Update edging values (in case they were autocompleted)
			leftEdging = $this.find('input[name="properties[Left Edging]"]:checked').val();
			topEdging = $this.find('input[name="properties[Top Edging]"]:checked').val();
			bottomEdging = $this.find('input[name="properties[Bottom Edging]"]:checked').val();
			rightEdging = $this.find('input[name="properties[Right Edging]"]:checked').val();
			edgingThickness = $edgingThickness.val();

			if(leftEdging == 'Yes') {
				leftEdgingProp = edgingThickness;
			} else {
				leftEdgingProp = 'None';
			}

			if(topEdging == 'Yes') {
				topEdgingProp = edgingThickness;
			} else {
				topEdgingProp = 'None';
			}

			if(bottomEdging == 'Yes') {
				bottomEdgingProp = edgingThickness;
			} else {
				bottomEdgingProp = 'None';
			}

			if(rightEdging == 'Yes') {
				rightEdgingProp = edgingThickness;
			} else {
				rightEdgingProp = 'None';
			}

			hingeHoleQty = parseInt($hingeHoles.val());

			validateLength = true;
			validateWidth = true;

			validateMeasurements();

			if(panelLength && panelWidth && variantID) {
				// Disable button
				$submitButton.prop('disabled', true).addClass('is-adding');

				// Resetting
				cabjaks.itemsToAdd = [];

				panelProperties = {
					'Width': panelWidth + 'mm',
					'Length': panelLength + 'mm',
					'Left Edging': leftEdgingProp,
					'Top Edging': topEdgingProp,
					'Bottom Edging': bottomEdgingProp,
					'Right Edging': rightEdgingProp,
					'_customPrice': true,
					'_Colour': selectedColour
				};

				if(hingeHoleQty > 0) {
					//panelProperties['Drilled Hinge Holes'] = hingeHoleQty;
					var panelSide = '';
					if($hingeHoles.val().indexOf( 'short side' ) != -1){
						panelSide = ' holes short side'
					}
					if($hingeHoles.val().indexOf( 'long side' ) != -1){
						panelSide = ' holes long side'
					}
					panelProperties['Drilled Hinge Holes'] = hingeHoleQty + panelSide;
				}

				// Add main product to cart
				cabjaks.itemsToAdd.push({
					id: variantID, 
					quantity: qty,
					properties: panelProperties
				});

				// Add edging products to cart
				if(edging1Qty > 0) {
					cabjaks.itemsToAdd.push({
						id: $edging1.data('id'), 
						quantity: edging1Qty * qty
					});
				}

				if(edgingLong1Qty > 0) {
					cabjaks.itemsToAdd.push({
						id: $edgingLong1.data('id'), 
						quantity: edgingLong1Qty * qty
					});
				}

				if(edging2Qty > 0) {
					cabjaks.itemsToAdd.push({
						id: $edging2.data('id'), 
						quantity: edging2Qty * qty
					});
				}

				if(edgingLong2Qty > 0) {
					cabjaks.itemsToAdd.push({
						id: $edgingLong2.data('id'), 
						quantity: edgingLong2Qty * qty
					});
				}

				// Add hinge product to cart
				if(hingeHoleQty > 0) {
					cabjaks.itemsToAdd.push({ 
						id: $hingeHoles.data('id'),
						quantity: hingeHoleQty * qty
					});
				}
				
				// Start running through the queue
				if(cabjaks.itemsToAdd.length) {
					cabjaks.addMultipleItems();
				}
			}
		});				
	});
};

// Add multiple products to the cart using AJAX (for product upsells)
cabjaks.addMultipleItems = function() {
	if(cabjaks.itemsToAdd.length) {
		var item = cabjaks.itemsToAdd.pop();

		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: item,
			dataType: 'json'
		}).done(function() {
			cabjaks.addMultipleItems();
		}).fail(function() {
			$('button#AddToCart').prop('disabled', false).removeClass('is-adding');
			alert('Error adding items to the cart, please try again.');
		});

	} else {
		//window.location.href = '/cart';
		$('button#AddToCart').prop('disabled', false).removeClass('is-adding');
		$('.js-drawer-open-right').click(); //open minicart drawer

	}
};

cabjaks.productAdditional = function () {
	var $productAdditional = $('.product-single__upsells, .product-single__order-form'),
	$productUpsells = $('.product-single__upsells'),
	$productOrderForm = $('.product-single__order-form');

	//auto select soft close hinge
	$('.upsell-item').each(function() { 
		var $this = $(this); 
		if($this.find("h3").text().indexOf("Soft Close Hinges") > -1){
			cabjaks.softHingeChosen = true;
			$this.find('button').text("Selected").addClass("selected");
		}
		if($this.find("h3").text().indexOf("Corner Lazy Susan") > -1){
			// cabjaks.cornerLazySusanChosen = true;
			// $this.find('button').text("Selected").addClass("selected");
		}
		if($this.find("h3").text().indexOf("Standard Handle") > -1){
			cabjaks.handleChosen = true;
			$this.find('button').text("Selected").addClass("selected");
		}
	});

	// Toggle tabs
	$productAdditional.find('.tabs a').on('click', function(e) {
		e.preventDefault();

		var $this = $(this),
		$parentLi = $this.parent('li'),
		index = $this.parents('.tabs').find('li').index($parentLi);


		//disable clicking upsell-category tab if there is only 1 tab
		if($(this).is($('.product-single__upsells.cols-1 .tabs li .upsell-category'))){
			return false;
		}
		//toggle plus/minu icon
		$(this).parent('li').find(".mobile-nav__icon-minus, .mobile-nav__icon-plus").toggle();

		if($parentLi.hasClass('selected')) {
			if ($(window).width() <= 480) {
				$parentLi.removeClass('selected');
				$this.parents('.tabs').next('.content').removeClass('shown').find('> li').removeClass('selected');
			}

		} else {
			$parentLi.addClass('selected').siblings().removeClass('selected');
			$this.parents('.tabs').next('.content').addClass('shown').find('> li').eq(index).addClass('selected').siblings().removeClass('selected');
			
			if ($(window).width() > 480) {
				cabjaks.handleSlick();
				
			}
		}
	});

	//desktop - open first tab in slider
	if ($(window).width() > 480) {
		$productAdditional.find('.tabs li:first-child a').trigger('click');
	}

	// Close button
	$productAdditional.find('.close-btn').on('click', function(e) {
		e.preventDefault();
		var $this = $(this);

		$this.closest('li').removeClass('selected');
		$this.parents('.content').removeClass('shown').siblings('.tabs').find('li').removeClass('selected');
	});

	// On upsell button click
	$productUpsells.find('button').on('click', function(e) {
		var $this = $(this),
		upsellTitle;

		if($this.hasClass('selected')) {
			$this.text('Select').removeClass('selected');
			// Clear saved properties
			if($this.closest('li').hasClass('benchtops')) {
				$productUpsells.find('input.benchtop-info').val('').attr('name', '');
				cabjaks.benchtopChosen = false;
			} else if($this.closest('li').hasClass('sinks')) {
				$productUpsells.find('input.sink-info').val('').attr('name', '');
				cabjaks.sinkChosen = false;
			} else if($this.closest('li').hasClass('handles')) {
				cabjaks.handleChosen = false;
			} else if($this.closest('li').hasClass('soft-close')) {
				cabjaks.softCloseChosen = false;
			} else if($this.closest('li').hasClass('soft-hinge')) {
				cabjaks.softHingeChosen = false;
				$productUpsells.find('input.hinge-info').val('Soft Close').removeAttr('name', 'properties[Hinge Type]');
				$productUpsells.find('input.hinge-info').val('Standard').attr('name', 'properties[Hinge Type]');
			} else if($this.closest('li').hasClass('lazy-susan')) {
				cabjaks.cornerLazySusanChosen = false;
			}
		} else {
			// Check that it has a data ID (stops invalid benchtops being added)
			if($this.data('id')) {
				$this.text('Selected').addClass('selected');
				$this.closest('.upsell-item').siblings().find('button').removeClass('selected').text('Select');
				// Add properties
				if($this.closest('li').hasClass('benchtops')) {
					upsellTitle = $this.closest('.upsell-item').find('h3').first().text().trim();
					$productUpsells.find('input.benchtop-info').val(upsellTitle).attr('name', 'properties[_Benchtop]');
					cabjaks.benchtopChosen = true;
				} else if($this.closest('li').hasClass('sinks')) {
					upsellTitle = $this.closest('.upsell-item').find('h3').first().text().trim();
					$productUpsells.find('input.sink-info').val(upsellTitle).attr('name', 'properties[_Sink]');
					cabjaks.sinkChosen = true;
				} else if($this.closest('li').hasClass('handles')) {
					cabjaks.handleChosen = true;
				} else if($this.closest('li').hasClass('soft-close')) {
					cabjaks.softCloseChosen = true;
				} else if($this.closest('li').hasClass('soft-hinge')) {
					cabjaks.softHingeChosen = true;
				} else if($this.closest('li').hasClass('lazy-susan')) {
					cabjaks.cornerLazySusanChosen = true;
				}
			}
		}

		cabjaks.updateUpsellProductPrice();

		e.preventDefault();
	});

	// Add upsell items to cart
	$('form#AddToCartForm').submit(function(event) {
		event.preventDefault();
		var $this = $(this),
		$submitButton = $this.find('button#AddToCart'),
		sinkPosition = $this.find('select#sink-position').val(),
		qty = parseInt($this.find('.js-qty input').val(), 10);

		$.getJSON("/cart.js")
			.done(function (response) {
				let skipColourValidation = false;
				if($this.data('collections').includes('Wardrobe Extras') ||
				$this.data('collections').includes('Handles')||
				$this.data('collections').includes('Accessories')||
				$this.data('collections').includes('Appliances')||
				$this.data('collections').includes('Sinks and Tapware')||
				$this.data('collections').includes('Benchtop Blanks')){
					skipColourValidation = true;
				}
				//validate colour firsts
				if(!skipColourValidation){
				for (var i = 0; i < response.items.length; i++) {
					if (response.items[i].product_title != 'Custom Benchtop' && !response.items[i].product_title.includes('Custom Stone') && !response.items[i].product_title.includes('Benchtop') && response.items[i].properties) {
						for (const [key, value] of Object.entries(response.items[i].properties)) {
							if (key == 'Colour' || key == '_Colour') {
								if (value.toLowerCase() != 'white') {
									Swal.fire({
										text: "Only one cabinet or wardrobe colour can be in the shopping cart per order. If you wish to purchase multiple colours please place separate orders.",
										icon: 'error',
										confirmButtonColor: '#3085d6',
										cancelButtonColor: '#d33',
										confirmButtonText: 'OK'
									});
									return false;
								}
							}
						}
					}
				}
			}

				//if preconfigured wardrobe product, use the main product qty selector at bottom of page, to avoid using the preconfigured sub product qty
		if($('.product-single__order-form').length > 0){
			qty = parseInt($this.find('.product-single__js-qty.js-qty input').val(), 10);
		}

		// Only use AJAX add to cart if there's upsells (to stop redundant properties being added to the upsells)
		if(cabjaks.benchtopChosen || cabjaks.sinkChosen || cabjaks.handleChosen || cabjaks.softCloseChosen || cabjaks.softHingeChosen || cabjaks.cornerLazySusanChosen) {
				
			// Require sink position if both benchtop and sink are selected
		if(cabjaks.benchtopChosen && cabjaks.sinkChosen && !sinkPosition) {
 		 Swal.fire({
   		 text: "Please select a sink position before adding this kitchenette to your cart.",
  		  icon: 'error',
  		  confirmButtonColor: '#6dcff6',
   		 confirmButtonText: 'OK'
		  });

  return false;
}
			
			// Reset conditional properties first
			$productUpsells.find('input.sink-position-info').val('').attr('name', '');
			$productUpsells.find('input.drawer-info').val('').attr('name', '');
			$productUpsells.find('input.hinge-info').val('').attr('name', '');


			// Add sink position to cabinet only if sink and benchtop are both chosen
			if(cabjaks.benchtopChosen && cabjaks.sinkChosen && sinkPosition) {
  			$productUpsells.find('input.sink-position-info')
    		.val(sinkPosition)
    		.attr('name', 'properties[_Sink Position]');
			}

			// Add drawer type independently of sink availability
			if(cabjaks.softCloseChosen) {
 			 $productUpsells.find('input.drawer-info')
  			  .val('Soft Close')
  			  .attr('name', 'properties[Drawer Type]');
			}
      
			// Add hinge type independently of sink availability
			if(cabjaks.softHingeChosen) {
  			$productUpsells.find('input.hinge-info')
    			.val('Soft Close')
   			 .attr('name', 'properties[Hinge Type]');
			}

			// Disable button
			$submitButton.prop('disabled', true).addClass('is-adding');

			// Resetting
			cabjaks.itemsToAdd = [];

			// Add main product to cart
			cabjaks.itemsToAdd.push($this.serialize());

			// Add upsells to cart
			$this.find('.upsell-item button.selected').each(function() {
				var $upsellItem = $(this),
				upsellQty = qty,
				upsellProperties = {},
				addUpsellToCart = true;

				// Add 'Sink Cutout' info to benchtop if sink has also been chosen
				if($upsellItem.closest('li').hasClass('benchtops') && cabjaks.sinkChosen) {
					var sinkType = $productUpsells.find('input.sink-info').val(),
					drawerSide = false;

					// Find drawer side
					$('.selector-wrapper').each(function(index) {
						if($(this).find('label').text() == 'Drawer Side') {
							drawerSide = $(this).find('select.single-option-selector').val();
						}
					});

					if(sinkPosition) {
						if(drawerSide) {
							upsellProperties = {
								'Sink Cutout': 'Yes',
								'Sink': sinkType,
								'Sink Position': sinkPosition,
								'_Drawer Side': drawerSide
							};
						} else {
							upsellProperties = {
								'Sink Cutout': 'Yes',
								'Sink': sinkType,
								'Sink Position': sinkPosition
							};
						}
					} else {
						if(drawerSide) {
							upsellProperties = {
								'Sink Cutout': 'Yes',
								'Sink': sinkType,
								'_Drawer Side': drawerSide
							};
						} else {
							upsellProperties = {
								'Sink Cutout': 'Yes',
								'Sink': sinkType
							};
						}
					}
				}

				// Adjust handle quantity
				if($upsellItem.closest('li').hasClass('handles')) {
					upsellQty = $upsellItem.data('qty') * qty;

					// Mark wardrobe handle upgrades separately (so they don't end up in the cabinet order printout)
					if($productUpsells.hasClass('is-wardrobe-component')) {
						upsellProperties = {
							'_Upgrade Type': 'Wardrobe'
						};
					}
        }
        
        // Adjust hinges quantity
				if($upsellItem.closest('li').hasClass('soft-hinge')) {
          upsellQty = $upsellItem.data('qty') * qty;
				}

				// Soft close drawers
				if($upsellItem.closest('li').hasClass('soft-close')) {
					softCloseShortQty = $upsellItem.data('shortqty');
					softCloseTallQty = $upsellItem.data('tallqty');

					if(softCloseShortQty) {
						cabjaks.itemsToAdd.push({ 
							id: $upsellItem.data('shortid'), 
							quantity: softCloseShortQty * qty
						});
					}

					if(softCloseTallQty) {
						cabjaks.itemsToAdd.push({ 
							id: $upsellItem.data('tallid'), 
							quantity: softCloseTallQty * qty
						});
					}

					// Already added
					addUpsellToCart = false;
				}

				if($upsellItem.closest('li').hasClass('benchtops')) {
					upsellProperties['_customPrice'] = true;
				}

				// Add to cart if required
				if(addUpsellToCart) {
					cabjaks.itemsToAdd.push({ 
						id: $upsellItem.data('id'), 
						quantity: upsellQty,
						properties: upsellProperties,
						title: $upsellItem.data('title')
					});
				}
			});

			//Warning message for 1200mm wide tall cabinets
			if(cabjaks.currentVariantDetails.name.includes('Tall Cabinet') && cabjaks.currentVariantDetails.name.includes('1200')){
				$submitButton.prop('disabled', false).removeClass('is-adding');

				Swal.fire({
					title: 'This is a big cabinet',
					text: 'Is access for delivery going to be an issue? If so try  2 x 600 cabinets instead.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Continue'
				  }).then((result) => {
					if (result.isConfirmed) {

						$submitButton.prop('disabled', true).addClass('is-adding');

						  // Start running through the queue
						if(cabjaks.itemsToAdd.length) {
							cabjaks.addMultipleItems();
						}
					}
				  });
				  return;
			}
			//End Warning message for 1200mm wide tall cabinets

			// Start running through the queue
			if(cabjaks.itemsToAdd.length) {				
				// Check for both items
				let hasItem1 = false; //corner base cabinet
				let hasItem2 = false; //corner lazy susan
				
				cabjaks.itemsToAdd.forEach(item => {
					if(typeof item === 'string' && item.includes('product_title=Corner+Base+Cabinet')) hasItem1 = true;
					if(item.title === 'Corner Lazy Susan') hasItem2 = true;
				});

				// If both items exist, add property to item1
				if(hasItem1 && hasItem2) {
					cabjaks.itemsToAdd.forEach((item, index) => {
						if(typeof item === 'string' && item.includes('product_title=Corner+Base+Cabinet')){
							cabjaks.itemsToAdd[index] += '&properties%5B_Corner_Lazy_Susan%5D=True';
						}

						if(item.title === 'Corner Lazy Susan') {
							item.properties = item.properties || {};
							item.properties["_parent_cabinet_id"] = '1223109421';
						}					
					});
				}

				// Start running through the queue
				cabjaks.addMultipleItems();
			}

			return false;
		}

		//remove additional properties if sink position to cabinet if sink and benchtop NOT chosen/deselected
		if(!cabjaks.benchtopChosen && !cabjaks.sinkChosen && !sinkPosition) {
			$productUpsells.find('input.sink-position-info').val(sinkPosition).removeAttr('name', 'properties[_Sink Position]');
		}
		//remove additional properties if soft close drawer NOT chosen/deselected
		if(!cabjaks.softCloseChosen) {
			$productUpsells.find('input.drawer-info').val('Soft Close').removeAttr('name', 'properties[Drawer Type]');
    }
    
    if(!cabjaks.softHingeChosen) {
			$productUpsells.find('input.hinge-info').val('Soft Close').removeAttr('name', 'properties[Hinge Type]');
			$productUpsells.find('input.hinge-info').val('Standard').attr('name', 'properties[Hinge Type]');
		}

		// Process order form
		if($this.hasClass('ajax-order-form')) {
			// Disable button
			$submitButton.prop('disabled', true).addClass('is-adding');

			// Resetting
			cabjaks.itemsToAdd = [];

			// Add products to cart
			$this.find('.form-item').each(function() {
				var $formItem = $(this),
				lineQty = parseInt($formItem.find('input[name=quantity]').val(), 10);

				if(lineQty > 0) {
					cabjaks.itemsToAdd.push({
						id: $formItem.find('input.selected').data('id'), 
						quantity: lineQty * qty,
						properties: {'_Colour': 'White'}
					});
				}
			});

			// Start running through the queue
			if(cabjaks.itemsToAdd.length) {
				cabjaks.addMultipleItems();
			}

			return false;
		}

			});
		
	});

	cabjaks.updateUpsellProductPrice();
};

cabjaks.productImageSwitch = function () {
	if (cabjaks.cache.$thumbImages.length) {
		// Switch the main image with one of the thumbnails
		// Note: this does not change the variant selected, just the image
		cabjaks.cache.$thumbImages.on('click', function(evt) {
			evt.preventDefault();
			var newImage = $(this).attr('href'),
			newImageSrcset = $(this).data('srcsetlarge');
			cabjaks.switchImage(newImage, newImageSrcset, cabjaks.cache.$productImage);

			$('.product-single__thumbnails').find('img').removeClass('active-thumbnail');
			$(this).find('img').addClass('active-thumbnail');
		});
	}
};

cabjaks.switchVariantImage = function (image, element) {
	if (!image || !element) {
		return;
	}

	var $el = $(element),
	size = Shopify.Image.imageSize(element.src),
	imageUrl = Shopify.Image.getSizedImageUrl(image.src, size),
	srcsetSize = $el.data('srcsetsize'),
	imageUrlSrcset = Shopify.Image.getSizedImageUrl(image.src, srcsetSize);

	cabjaks.switchImage(imageUrl, imageUrlSrcset, element);
};

cabjaks.switchImage = function (src, srcset, el) {
	// Make sure element is a jquery object
	var $el = $(el),
	srcsetMag = $el.data('srcsetmag'),
	srcsetFinal = srcset + ' ' + srcsetMag;

	$el.attr('src', src).attr('srcset', srcsetFinal);
};

cabjaks.responsiveVideos = function () {
	$('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
	$('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
};

cabjaks.googleMap = function() {
	// If the Google Maps JS has been included (it's only included on the contact page)
	if(typeof google != "undefined") {
		var myLatLng = new google.maps.LatLng(-36.94028,174.88194),
		myOptions = {
			zoom: 15,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: myLatLng
		},
		map = new google.maps.Map(document.getElementById("google-map"), myOptions),
		marker = new google.maps.Marker({
			clickable: false,
			position: myLatLng,
			map: map
		});
	}
};

cabjaks.handleSlick = function() {
  $('.product-single__upsells .content li.selected').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
	arrows:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true
        }
	  },
	  {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
		}
	  },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 481,
        settings: "unslick"
      }
    ]
  });
};

// display total product price including upsell items
cabjaks.updateUpsellProductPrice = function() {
	let totalUpsellItemsPrice = 0;
	let upsellProductPrice = $('#ProductPrice').attr('data-product-price').replace(/[$,]+/g,"");

	$('.product-single__upsells').find('.upsell-item button.selected').each(function() {
		let upsellItemPrice = $(this).closest('.upsell-item').find('.product-info-desktop .price').text().replace(/[$,]+/g,"");
		if (upsellItemPrice.includes('each')) {
			upsellEachItemPrice = upsellItemPrice.replace(' each',"");
			upsellEachTotal = $(this).closest('.upsell-item').find('.product-info-desktop .handle_count_msg').text().replace(/[\(\)]/g,"").split('')[0];
			totalUpsellItemsPrice += parseFloat(upsellEachItemPrice * upsellEachTotal);
		}
		if(upsellItemPrice > 0) {
			totalUpsellItemsPrice += parseFloat(upsellItemPrice);
		}
	});
	
	let totalUpsellPrice = '$' + (totalUpsellItemsPrice + parseFloat(upsellProductPrice)).toFixed(2);
	$('#ProductPrice').html( totalUpsellPrice );
};

cabjaks.orderForm = function() {
	$('.order-form__add-to-cart').on('click', function() {
		var $this = $(this);

		// Disable button
		$this.prop('disabled', true).addClass('is-adding');

		// Resetting
		cabjaks.itemsToAdd = [];

		// Add products to cart
		$('.ajax-order-form input.item-qty').each(function() {
			var $formItem = $(this),
			lineQty = parseInt($formItem.val(), 10);

			if(lineQty > 0) {
				cabjaks.itemsToAdd.push({
					id: $formItem.data('id'), 
					quantity: lineQty
				});
			}
		});

		// Start running through the queue
		if(cabjaks.itemsToAdd.length) {
			cabjaks.addMultipleItems();
		} else {
			$this.prop('disabled', false).removeClass('is-adding');
		}
	});

	$('.ajax-order-form input.item-qty').on('click', function() {
		this.select();
	});

	$('.ajax-order-form input[max]').on('change', function() {
		var max = parseInt($(this).attr('max'), 10);
		var value = parseInt($(this).val(), 10) || 0;
		if(value > max) { 
			alert('Sorry, we only have ' + max + ' of this item in stock.');
			$(this).val(max);
		}    
	});
};

cabjaks.cartDateRequired = function() {
	function getWorkingDays(workingDays, holidays) {
		var d = new Date(),
		day = d.getDay(),
		returnDays = workingDays,
		productionDay,
		productionDate,
		productionDateFormatted,
		j = 1;

		// Loop through days, add extra days for Saturday/Sunday
		for(var i = (day + 1); i <= (day + workingDays); i++) {
			productionDay = i;

			// If 7 or 14, make 0 (Sunday is 0)
			if(productionDay >= 7) {
				productionDay = productionDay % 7;
			}

			// If production day is Saturday or Sunday, add extra day
			if(productionDay == 6 || productionDay == 0) {
				returnDays++;
				workingDays++;

			// Otherwise add extra days if holiday occurs on working day
			} else {
				// Format production date
				productionDate = new Date();
				productionDate.setDate(productionDate.getDate() + j);
				productionDateFormatted = productionDate.getFullYear() + '-' + ('0' + (productionDate.getMonth() + 1)).slice(-2) + '-' + ('0' + productionDate.getDate()).slice(-2);

				// If date matches a holiday, add extra working day
				if (holidays.indexOf(productionDateFormatted) > -1) {
					returnDays++;
					workingDays++;
				}
			}

			j++;
		}

		return returnDays;
	}

	$(document).on('click', '.option-calendar', function() {var holidays = ['2026-10-24', '2026-10-26', '2026-12-23', '2026-12-24', '2026-12-25', '2026-12-26', '2026-12-27', '2026-12-28', '2026-12-29', '2026-12-30', '2026-12-31', '2026-01-01', '2026-01-02', '2026-01-03', '2026-01-04', '2026-01-30', '2026-02-01', '2026-02-06', '2026-02-08', '2026-03-26', '2026-03-27', '2026-03-29', '2026-04-24', '2026-04-26'];

		let leadTime = 5;
		if($('[data-cart-item-with-colour]').length){
			leadTime = 12;
		}
		$('input#date-required-calendar').datepicker({
			dateFormat: 'DD d MM yy',
			altField: 'input#date-required-attribute',
			minDate: getWorkingDays(leadTime, holidays),
			maxDate: '+2M',
			beforeShowDay: function(date) {
				// Hide Sundays and Holidays
				var day = date.getDay(),
				dateString = jQuery.datepicker.formatDate('yy-mm-dd', date);

				if((day != 0) && holidays.indexOf(dateString) == -1) {
					return [true];
				} else {
					return [false];
				}
			},
			onSelect: function(dateText) {
				$('.option-calendar .date-text').text(dateText);
				$('.option-calendar .errors').removeClass('shown');
				$('.option-calendar label').removeClass('error');
			}
		}).datepicker('show');

		//no translate on datepicker
		$('.ui-datepicker').addClass('notranslate');

	});

	$(document).on('click', '.option-calendar-colour', function() {var holidays = ['2026-10-24', '2026-10-26', '2026-12-23', '2026-12-24', '2026-12-25', '2026-12-26', '2026-12-27', '2026-12-28', '2026-12-29', '2026-12-30', '2026-12-31', '2026-01-01', '2026-01-02', '2026-01-03', '2026-01-04', '2026-01-30', '2026-02-01', '2026-02-06', '2026-02-08', '2026-03-26', '2026-03-27', '2026-03-29', '2026-04-24', '2026-04-26'];

		let leadTime = 12;

		$('input#date-required-calendar-colour').datepicker({
			dateFormat: 'DD d MM yy',
			altField: 'input#date-required-attribute-colour',
			minDate: getWorkingDays(leadTime, holidays),
			maxDate: '+2M',
			beforeShowDay: function(date) {
				// Hide Sundays and Holidays
				var day = date.getDay(),
				dateString = jQuery.datepicker.formatDate('yy-mm-dd', date);

				if((day != 0) && holidays.indexOf(dateString) == -1) {
					return [true];
				} else {
					return [false];
				}
			}
		}).datepicker('show');

		//no translate on datepicker
		$('.ui-datepicker').addClass('notranslate');
	});

	// On checkout click
	$(document).on('click', 'input[name="checkout"]', function(e) {
		// Show error if no date chosen
		if(!($('input#date-required-attribute').val())) {
			$('.option-calendar .errors').addClass('shown');
			$('.option-calendar label').addClass('error');

			// Scroll down to error
			$('html, body').animate({
				scrollTop: $('.cart__date-required').offset().top - 15
			});

			return false;
		}

		if (!$('.cart__terms #agree').is( ":checked" )) {
			$('.cart__terms').append('<p class="errors">Please agree to the terms and conditions</p>')
			return false;
		}

		e.preventDefault();
		var cartAttributeList = {
			'Date required': $('#date-required-attribute').val(),
			'No handle holes': $('#attribute_1').length ? ($('#attribute_1').is( ":checked" )?'Yes':'No'):'',
			'No handles or handle holes': $('#attribute_2').length ? ($('#attribute_2').is( ":checked" )?'Yes':'No'):'',
			'No doors but include hinges and mounts': $('#attribute_3').length ? ($('#attribute_3').is( ":checked" )?'Yes':'No'):'',
			'No doors. No hinges or mounts': $('#attribute_4').length ? ($('#attribute_4').is( ":checked" )?'Yes':'No'):''			
		};
		$.ajax({
			type: "POST",
			url: '/cart/update.js',
			data: { attributes: cartAttributeList },
			dataType: 'json'
		}).done(function() {
			document.location.href = '/cart/checkout';
		});
	});
};

// Initialize JS on document ready
$(cabjaks.init);
